import type { Router, RouteRecordRaw } from 'vue-router';

import { usePermissionStoreWithOut } from '@/store/modules/permission';

import { PageEnum } from '@/enums/pageEnum';
import { useUserStoreWithOut } from '@/store/modules/user';
import { useCommonStore } from '@/store/modules/common';
// import { getSSOLoginUrl } from '@/utils/ssologin';

import { PAGE_NOT_FOUND_ROUTE } from '@/router/routes/basic';

const LOGIN_PATH = PageEnum.BASE_LOGIN;

const whitePathList: PageEnum[] = [LOGIN_PATH, PageEnum.BASE_OFFLINE];

// 注册路由
export function createPermissionGuard(router: Router) {
  const userStore = useUserStoreWithOut();
  const permissionStore = usePermissionStoreWithOut();
  router.beforeEach(async (to, from, next) => {
    const token = userStore.getToken;
    // Whitelist can be directly entered
    if (to.path.includes('exception')) {
      next();
      return;
    }
    if (whitePathList.includes(to.path as PageEnum)) {
      if (token) {
        const isSessionTimeout = userStore.getSessionTimeout;
        try {
          //登录后根据角色进行路由注册
          await userStore.afterLoginAction();
          if (!isSessionTimeout) {
            const commonStore = useCommonStore();
            if (!commonStore.getUserInfo.name) {
              await commonStore.init();
            }
            next((to.query?.redirect as string) || PageEnum.BASE_HOME);
            return;
          }
        } catch {
          //
        }
      }
      // 如果登录地址是oss登录地址，直接跳转到oss登录页面
      if (to.path === PageEnum.BASE_OFFLINE) {
        userStore.setToken('astore');
        // window.location.href = getSSOLoginUrl();
        next();
        return;
      }
      // 线上门店输入账号登录，进入输入账号登录页面
      next();
      return;
    }

    // token or user does not exist
    // if (!token) {
    //   // You can access without permission. You need to set the routing meta.ignoreAuth to true
    //   if (to.meta.ignoreAuth) {
    //     next();
    //     return;
    //   }

    //   // redirect login page
    //   const redirectData: { path: string; replace: boolean; query?: Recordable<string> } = {
    //     path: LOGIN_PATH,
    //     replace: true,
    //   };
    //   if (to.path) {
    //     redirectData.query = {
    //       ...redirectData.query,
    //       redirect: to.path,
    //     };
    //   }
    //   next(redirectData);
    //   return;
    // }

    // Jump to the 404 page after processing the login
    if (
      from.path === LOGIN_PATH &&
      to.name === PAGE_NOT_FOUND_ROUTE.name &&
      to.fullPath !== PageEnum.BASE_HOME
    ) {
      next(PageEnum.BASE_HOME);
      return;
    }

    // get userinfo while last fetch time is empty
    // if (userStore.getLastUpdateTime === 0) {
    //   try {
    //     await userStore.getUserInfoAction();
    //   } catch (err) {
    //     next();
    //     return;
    //   }
    // }
    if (PageEnum.BASE_HOME === '' && token) {
      try {
        // sso登录后，获取用户信息
        const commonStore = useCommonStore();
        await commonStore.setUserInfo();
      } catch (err) {
        next();
        return;
      }
    }
    if (permissionStore.getIsDynamicAddedRoute) {
      next();
      return;
    }
    if (token) {
      const routes = await permissionStore.buildRoutesAction();
      if (routes.length) {
        routes.forEach((route) => {
          router.addRoute(route as unknown as RouteRecordRaw);
        });
        permissionStore.setDynamicAddedRoute(true);
      }
    }
    router.addRoute(PAGE_NOT_FOUND_ROUTE as unknown as RouteRecordRaw);
    if (to.name === PAGE_NOT_FOUND_ROUTE.name) {
      // 动态添加路由后，此处应当重定向到fullPath，否则会加载404页面内容
      next();
      // next();
    } else {
      const redirectPath = (from.query.redirect || to.path) as string;
      const redirect = decodeURIComponent(redirectPath);
      const nextData = to.path === redirect ? { ...to, replace: true } : { path: redirect };
      next(nextData.path === '/' ? PageEnum.BASE_HOME : nextData);
    }
  });
}
